import { fetchClassifications } from "@/api/classification";
import { toTree } from '@/utils/tree';
import types from "../types";

const state = {
  classifications: [],
  classificationTree: []
};

const mutations = {
  [types.SET_CLASSIFICATIONS](state, classifications) {
    state.classifications = classifications;
    state.classificationTree = toTree(classifications);
  }
};

const actions = {
  fetchClassifications({ commit }) {
    return fetchClassifications()
      .then(res => {
        const { data: classifications } = res.data;
        commit(types.SET_CLASSIFICATIONS, classifications || []);
      })
      .catch(error => {
        Promise.reject(error);
      });
  }
};

export default {
  state,
  mutations,
  actions
};


// WEBPACK FOOTER //
// ./src/store/modules/classification.js